/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { Table, FlexboxGrid, Schema } from 'rsuite';
import { toast } from 'react-toastify';
import { Plus } from '@rsuite/icons';

import { Container } from '~/styles/tabela';

import api from '~/services/api';
import {
  CelulaEditavel,
  CelulaAcao,
} from '~/components/Celulas/components/CelulaEditavel';
import { ModalIcon } from '~/components/ModalCriacao/ModalIcon';
import { Modal2 } from '~/components/ModalCriacao/Modal2';
import { Modal1 } from '~/components/ModalCriacao/Modal1';
import { TabelaSemPaginacao } from '~/components/TabelaSemPaginacao';
import SearchTable from '../components/SearchTable';
import PageHeader from '../../../components/PageHeader';
import Card from '../../../components/Card';

const { HeaderCell, Column } = Table;

const { StringType } = Schema.Types;

const modelo = Schema.Model({
  descricao: StringType().isRequired('Descrição da categoria Obrigatório'),
});

function CategoriasQuestoes() {
  const [dados, setDados] = useState({
    categoriasQuestoesLista: [],
    categoriasQuestoesListaFiltrada: [],
    filtro: '',
    objeto: {},
  });
  // const [dados, setDados] = useState();
  const [apagarCategoriaQuestao, setApagarCategoriaQuestao] = useState({
    exibir: false,
    descricao: {},
  });
  const [carregando, setCarregando] = useState(true);
  const [adicionarCategoriaQuestao, setAdicionarCategoriaQuestao] = useState(false);
  const [camposInput, setCamposInput] = useState({});

  async function buscarCategorias() {
    const resposta = await api.get('categorias-questoes');
    const resposta2 = await api.get('categorias-questoes');
    setDados({
      categoriasQuestoesLista: resposta.data.categorias,
      categoriasQuestoesListaFiltrada: resposta.data.categorias,
      listaInicial: resposta2.data.categorias,
    });
    setCarregando(false);
  }

  useEffect(() => {
    buscarCategorias();
  }, []);

  function filtrarLista(texto) {
    setDados({
      ...dados,
      categoriasQuestoesListaFiltrada: dados.categoriasQuestoesLista.filter((descricao) =>
        descricao.nome
          .toString()
          .toUpperCase()
          .includes(texto ? texto.toUpperCase() : '')
      ),
      filtro: texto,
    });
  }

  function abrirApagarDialog(descricao) {
    setApagarCategoriaQuestao({
      exibir: true,
      descricao,
    });
  }

  function fecharApagarDialog() {
    setApagarCategoriaQuestao({
      exibir: false,
      descricao: {},
    });
  }

  async function excluirCategoriaQuestao() {
    try {
      await api.delete(`/categorias-questoes/${apagarCategoriaQuestao.descricao.id}`);
      toast.success('Categoria excluida com sucesso');
      fecharApagarDialog();
      buscarCategorias();
    } catch (e) {
      toast.error(e.message);
    }
  }

  async function AdicionarCategoriaQuestao() {
    try {
      setCarregando(true);
      await api.post(`/categorias-questoes`, camposInput);
      toast.success('Categoria criada com sucesso');
      setCarregando(false);
      setAdicionarCategoriaQuestao(false);
      buscarCategorias();
    } catch (e) {
      toast.error(e.message);
    }
  }

  function alterarTextoCelula(id, key, value) {
    const nextData = Object.assign([], dados.categoriasQuestoesLista);
    nextData.find((item) => item.id === id)[key] = value;
    setDados({ ...dados, categoriasQuestoesLista: nextData });
    filtrarLista(dados.filtro);
  }

  async function alterarEstadoCelula(id) {
    const novaLista = Object.assign([], dados.categoriasQuestoesLista);
    const item = novaLista.find((descricao) => descricao.id === id);
    const itemIncial = dados.listaInicial.find((descricao) => descricao.id === id);
    if (item.status === 'EDIT' && item.nome !== itemIncial.nome) {
      try {
        setCarregando(true);
        await api.put(`categorias-questoes/${id}`, item);
        toast.success('Categoria atualizada com sucesso');
        buscarCategorias();
      } catch (error) {
        toast.error(error.message);
      }
      setCarregando(false);
    } else {
      item.status = item.status ? null : 'EDIT';
      setDados({ ...dados, categoriasQuestoesLista: novaLista });
      filtrarLista(dados.filtro);
    }
  }

  return (
    <Container>
      <PageHeader
              title="Categorias das Questões"
              subtitle="Aqui vocês pode gerenciar as categorias das questões."
            />
            <Card>
      <FlexboxGrid justify="start" style={{ gap: '10px' }}>
        <SearchTable estilo={{ width: '300px' }} filtrarLista={filtrarLista} />
        <ModalIcon
          style={{ marginTop: '0' }}
          icon={<Plus />}
          onClick={() => {
            setAdicionarCategoriaQuestao(true);
          }}
        />
      </FlexboxGrid>
      <FlexboxGrid style={{ width: '100%' }}>
        <TabelaSemPaginacao
          carregando={carregando}
          dados={dados.categoriasQuestoesListaFiltrada}
          // dados={dados}
        >
          <Column resizable width={240} sortable>
            <HeaderCell>Nome</HeaderCell>
            <CelulaEditavel dataKey="nome" onChange={alterarTextoCelula} />
          </Column>

          <Column resizable width={200}>
            <HeaderCell>Editar</HeaderCell>
            <CelulaAcao
              dataKey="id"
              onClick={alterarEstadoCelula}
              onDelete={abrirApagarDialog}
            />
          </Column>
        </TabelaSemPaginacao>
      </FlexboxGrid>
      </Card>

      <Modal1
        show={adicionarCategoriaQuestao}
        onHide={() => setAdicionarCategoriaQuestao(false)}
        title="Adicionar categoria"
        label="Categoria"
        name="nome"
        model={modelo}
        onSubmit={() => AdicionarCategoriaQuestao()}
        // onSubmit={(status) => status && AdicionarCategoriaQuestao()}
        onChange={setCamposInput}
        onClick={() => setAdicionarCategoriaQuestao(false)}
      />

      <Modal2
        show={apagarCategoriaQuestao.exibir}
        onHide={fecharApagarDialog}
        item="Categoria"
        title="Apagar categoria"
        text="Você realmente deseja apagar esta Categoria ?"
        apagarId={apagarCategoriaQuestao.descricao.id}
        apagarDado={apagarCategoriaQuestao.descricao.nome}
        fecharApagarDialog={fecharApagarDialog}
        excluir={() => excluirCategoriaQuestao()}
      />
    </Container>
  );
}

export default CategoriasQuestoes;
